import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ClientProvider } from "@/context/ClientContext";
import { AppLayout } from "@/components/AppLayout";
import { Spinner } from "@/components/ui/page";

import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import Contacts from "@/pages/Contacts";
import ContactDetail from "@/pages/ContactDetail";
import ActivityPage from "@/pages/Activity";
import Deals from "@/pages/Deals";
import Referrals from "@/pages/Referrals";
import Reports from "@/pages/Reports";
import Clients from "@/pages/Clients";
import UsersPage from "@/pages/Users";
import Settings from "@/pages/Settings";
import ImportContacts from "@/pages/ImportContacts";
import EmailMarketing from "@/pages/EmailMarketing";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <div className="min-h-screen grid place-items-center"><Spinner /></div>;
  if (!user) return <Navigate to="/login" replace />;
  const mustChange = user.must_change_password && location.pathname !== "/change-password";
  return <ClientProvider>{mustChange ? <Navigate to="/change-password" replace /> : children}</ClientProvider>;
}

function AdminOnly({ children }) {
  const { isSuperAdmin } = useAuth();
  if (!isSuperAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  useEffect(() => {
    document.title = "Brand Partners VSM Dashboard";
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><AppLayout /></Protected>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/contacts/:contactId" element={<ContactDetail />} />
              <Route path="/activity" element={<ActivityPage />} />
              <Route path="/deals" element={<Deals />} />
              <Route path="/referrals" element={<Referrals />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/email-marketing" element={<EmailMarketing />} />
              <Route path="/import" element={<ImportContacts />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/clients" element={<AdminOnly><Clients /></AdminOnly>} />
              <Route path="/users" element={<AdminOnly><UsersPage /></AdminOnly>} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
